import { Typography } from "@material-ui/core";
import * as React from "react";
import BaseFilter from "../../../core/models/BaseFilter";
import TankModel from "../../../core/models/Tank";
import {
  EVENT_EXPORT_EXCEL_LEVEL_HISTORY,
  EVENT_EXPORT_PDF_LEVEL_HISTORY,
  EVENT_INSTALLATION_LEVEL_HISTORY_FILTER_DATE_CHANGE,
  EVENT_INSTALLATION_LEVEL_HISTORY_FILTER_TANK_CHANGE,
  EVENT_INSTALLATION_LEVEL_HISTORY_SPLIT_TANKS_CHANGE,
} from "../../../Events";
import MaterialCustomSelectDate from "../../../features/SmartFilters/MaterialCustomSelectDate";
import { useHubx } from "../../../HubX";
import ButtonExport from "../../ButtonExport";
import ButtonSwitch from "../../ButtonSwitch";
import MaterialSelect from "../../MaterialSelect";

type InstallationLevelHistoryFilterProps = {
  tanks?: TankModel[];
  hasMoreThanOneTank?: boolean;
};

function InstallationLevelHistoryFilter({
  tanks,
  hasMoreThanOneTank = false,
}: InstallationLevelHistoryFilterProps) {
  const [useSelection, setSelection] = React.useState("all");
  const [splitTanks, setSplitTanks] = React.useState(false);
  const hub = useHubx();

  const handleChange = (event: React.ChangeEvent<{ value: string }>) => {
    const nextState = event.target.value;
    let sendFilterToEvent = nextState;

    if (nextState === "all") {
      sendFilterToEvent = "";
    }

    hub.notify(EVENT_INSTALLATION_LEVEL_HISTORY_FILTER_TANK_CHANGE, sendFilterToEvent);

    setSelection(event.target.value);
  };

  const handleClick = (newValueFromEvent: boolean) => {
    setSplitTanks(newValueFromEvent);
    hub.notify(EVENT_INSTALLATION_LEVEL_HISTORY_SPLIT_TANKS_CHANGE, newValueFromEvent);
  };

  const handleClickExportExcel = () => {
    hub.notify(EVENT_EXPORT_EXCEL_LEVEL_HISTORY, true);
  };

  const handleClickExportPdf = () => {
    hub.notify(EVENT_EXPORT_PDF_LEVEL_HISTORY, true);
  };

  const tanksSelect: BaseFilter | undefined = hasMoreThanOneTank
    ? {
        value: useSelection,
        handleChange,
        items: [
          { key: "all", value: "Todos" },
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          ...tanks!.map((tank) => {
            return {
              key: tank.tank_id,
              value: tank.tank_id,
            };
          }),
        ],
        id: "InstallationLevelHistoryTankSelect",
        label: "ID Tanque",
      }
    : undefined;

  return (
    <>
      {hasMoreThanOneTank && (
        <ButtonSwitch
          label="Separar tanques"
          onLabel="Sim"
          offLabel="Não"
          onClick={handleClick}
          value={splitTanks}
        />
      )}

      {splitTanks && tanksSelect && (
        <div className="selector">
          <Typography>Tanque:</Typography>
          <MaterialSelect filter={tanksSelect} />
        </div>
      )}

      <ButtonExport
        label="Exportar"
        onClickExcel={handleClickExportExcel}
        onClickPdf={handleClickExportPdf}
      />

      <MaterialCustomSelectDate event={EVENT_INSTALLATION_LEVEL_HISTORY_FILTER_DATE_CHANGE} />
    </>
  );
}

export default InstallationLevelHistoryFilter;
